import {
  initialUsersListState,
  SET_USERS_LIST,
  SET_USERS_LIST_FILTERS,
  SET_USERS_LIST_LOADING,
} from "./actions";

const initialUsers = {
  list: { ...initialUsersListState },
};

const users = (state = initialUsers, action) => {
  switch (action.type) {
    case SET_USERS_LIST_LOADING:
      return {
        ...state,
        list: {
          ...state.list,
          loading: action.payload,
        },
      };
    case SET_USERS_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          data: action.payload.data,
          total: action.payload.total,
        },
      };
    case SET_USERS_LIST_FILTERS:
      return {
        ...state,
        list: {
          ...state.list,
          filters: {
            ...state.list.filters,
            ...action.payload,
          },
        },
      };
    default:
      return state;
  }
};

export default users;

